import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";

export function AboutPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Om CasinoMenu.se" : "About CasinoMenu.se";
  const desc = isSv
    ? "CasinoMenu.se är en oberoende svensk jämförelseplattform för casinon, betalningsmetoder, bonusar, spel och betting."
    : "CasinoMenu.se is an independent Swedish comparison platform for casinos, payment methods, bonuses, games and betting.";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <article className="prose prose-ink mt-8 max-w-3xl [&>h2]:mt-10 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3 [&>ul]:my-3 [&>ul]:list-disc [&>ul]:pl-6">
        <h2>{isSv ? "Affiliateinformation" : "Affiliate disclosure"}</h2>
        <p>{t("affiliate.disclosure")}</p>
      </article>

      <InternalLinks context="static" />
    </div>
  );
}
